module.exports = __webpack_public_path__ + "static/media/(LH)_MG_6324_-_Joias_Contenporaneas.e9e61b5d.jpg";